import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { iRootState, Dispatch } from "../../../rematch/store";
import { IFilter, IFilterGroup } from "src/backend/interfaces/filters/IFilter";
import { random } from "lodash";
import { useTranslation } from "react-i18next";


interface ISavedFilterDropdownProps {
  viewIndex: number;
  isFiltersEnabled: (viewIndex: number) => boolean;
  isTemporaryFilter: (viewIndex: number) => boolean;
  getFilters: (viewIndex: number) => IFilterGroup[];
  enabledFilters: number[][];
  toggleEnabled: (viewIndex: number, filterName: string, ownerId: number) => void;
}

interface ISavedFiltersItemProps {
  checked: boolean;
  locked: boolean;
  external?: boolean;
  name: string;
  onChange: () => void;
}


const SavedFilterItem = (props: ISavedFiltersItemProps) => {

  const onClick = (event) => event.stopPropagation();
  
  return (
    <>
      <input 
        id={props.name}
        className="saved-filter-dropdown-list-item"
        type={"checkbox"} 
        onClick={onClick} 
        checked={props.checked} 
        onChange={props.onChange} 
        style={{ marginRight: '5px', position: 'relative', verticalAlign: 'middle', bottom: '2px' }}
      />
      <label htmlFor={props.name} style={{ cursor: 'pointer' }} >{props.name}</label>
    </>
  );
};

const SavedFilterDropdown = (props: ISavedFilterDropdownProps) => {

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { t } = useTranslation();
  const ref = useRef(null);
  const childRef = useRef(null);

  const id               = random(0, 100);
  const dropdownButtonId = "saved-filter-dropdown-button-" + id;
  const dropdownListId   = "saved-filter-dropdown-list-" + id;


  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target) && event.target.id !== dropdownButtonId) {

      if ( ref.current.style.display === "block" ) {
        ref.current.style.display = "none";
        setIsDropdownOpen(false);
      }
    }
  };


  useEffect(() => {

    const dropdownList = document.getElementById( dropdownListId );

    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        dropdownList.style.display = "none";
        setIsDropdownOpen( false );
      }
    };
    window.addEventListener('keydown', handleEsc, true);

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      window.removeEventListener('keydown', handleEsc, true);
      document.removeEventListener('click', handleClickOutside, true);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDropdownOpen]);

  const items = props.getFilters(props.viewIndex)?.map((mf, index) => {
    const checked = props.enabledFilters[props.viewIndex]?.includes(index);

    return (
      <SavedFilterItem
        key={`${mf.name}-${checked}`}
        locked={mf.locked}
        // external={f.ownerId !== props.userId}
        checked={checked}
        name={mf.name}
        onChange={() => props.toggleEnabled(props.viewIndex, mf.name, mf.ownerId)}
      />
    );
  })


  const getOffset = (el) => {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }


  const onButtonClick = (e) => {

    const dropdownList = document.getElementById( dropdownListId );

    if ( isDropdownOpen ) {

      dropdownList.style.display = "none";
      setIsDropdownOpen( false );

    } else {

      dropdownList.style.display = "block";

      const offset = getOffset(e.target);

      dropdownList.style.top     = `${offset.top + 24}px` ;
      dropdownList.style.left    = `${offset.left}px`;

      setIsDropdownOpen( true );
    }
  }


  return (
    <>
      <div 
        className="saved-filter-dropdown-container"
        style={{
          position: 'relative',
          display: 'inline-block',
        }}
      >

        <span
          id={dropdownButtonId}
          className="saved-filter-dropdown-button"
          style={{
            height: '40px',
            lineHeight: '40px',
            cursor: 'pointer'
          }}
          onClick={ (e) => onButtonClick(e) }
        >
          {t("filter.saved")}
        </span>

        <ul 
          ref={ref}
          id={dropdownListId}
          className="saved-filter-dropdown-list"
          style={{ 
            display: 'none',
            position: 'fixed',
            top: '100%',
            left: 0,
            zIndex: 999,
            backgroundColor: 'white',
            color: 'black',
            listStyle: 'none', 
            padding: '0', 
            margin: '0',
            maxHeight: '200px',
            overflow: 'auto',
          }}>
          { items.map( (item, index) => ( 
            <li 
              ref={childRef}
              key={index} 
              style={{ 
                margin: '0',
                marginRight: '25px', 
                whiteSpace: 'nowrap', 
                height: '30px', 
                lineHeight: '30px', 
                padding: '0 10px' 
              }} 
            >
              {item}
            </li> 
          ) ) }  
        </ul>

      </div>
    </>
  )

}

export default connect(
  (state: iRootState) => ({
    isFiltersEnabled: (viewIndex: number): boolean => state.filters.enabledPanelFilters[viewIndex]?.length > 0 ?? false,
    isTemporaryFilter: (viewIndex: number): boolean => state.filters.temporaryFilters[viewIndex] !== null,
    getFilters: (viewIndex: number) => state.filters.panelFilters[viewIndex] ?? [],
    enabledFilters: state.filters.enabledPanelFilters,
  }),
  (dispatch: Dispatch) => ({
    toggleEnabled: (viewIndex: number, filterName: string, ownerId: number) => dispatch.filters.toggleEnabled({ viewIndex, filterName, ownerId }),
  })
)(SavedFilterDropdown);